const XLSX = require('xlsx')
const { stateArray } = require('../shared/constants')
var fileSaver = require('file-saver')
var blob = require('blob-util')
const {
  flow,
  map,
  flattenDeep,
  find,
  findLast,
  filter
} = require("lodash/fp");

const excelUtility2B = {

  GSTR_ONE: (parsedData) => {

   //console.log(parsedData.gstrcdnr);
    
    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    var wb_new = XLSX.utils.book_new();
    

    if ((parsedData.gstrb2b !== undefined) && (parsedData.gstrb2b !== null) && (parsedData.gstrb2b.length !== 0)) {
        wb_new.SheetNames.push("GSTR-2B-B2B");
      }
      if ((parsedData.gstrcdnr !== undefined) && (parsedData.gstrcdnr !== null) && (parsedData.gstrcdnr.length !== 0)) {
        wb_new.SheetNames.push("GSTR-2B-CDNR");
      }
      var b2bDataList = [];
      var cdnrDataList = [];

      if ((parsedData.gstrb2b !== undefined) && (parsedData.gstrb2b !== null)) {

        const Data = flow(map(Inv => {
          const InvoiceItems = map(InvoiceItems => {
            return {
              'Supplier Gstin': Inv.supplier_gstin,
              'Supplier Name*': Inv.supplier_name,
              'Invoice No.*': Inv.invoice_number,
              'Invoice Date*': Inv.invoice_date,
              'Invoice Value*': parseFloat(Inv.invoice_value),
              'Invoice Type*': (Inv.invoice_type === 'R' ? 'Regular' : Inv.invoice_type),
              'Supplier Filing Date': Inv.supplier_filing_date,
              'Supplier Return Period*': Inv.supplier_return_period,
              'Place Of Supply*': Inv.pos_id,
              'Supply Type*': Inv.supply_type,
              'Reverse Charge*': Inv.reverse_charge,
              'Rate*': parseFloat(InvoiceItems.gst_rate),
              'Taxable Value*': parseFloat(InvoiceItems.taxable_value),
              'Integrated Tax*': (InvoiceItems.igst === null ? '' : parseFloat(InvoiceItems.igst)),
              'Central Tax*': (InvoiceItems.cgst === null ? '' : parseFloat(InvoiceItems.cgst)),
              'State/UT Tax*': (InvoiceItems.sgst === null ? '' : parseFloat(InvoiceItems.sgst)),
              'Cess': (InvoiceItems.cess === null ? '' : parseFloat(InvoiceItems.cess)),
          }
        })(Inv.gstr2b_b2b_items.edges)
          return InvoiceItems;
        }),
      flattenDeep)(parsedData.gstrb2b)

      b2bDataList = Data;

      }

      if ((parsedData.gstrcdnr !== undefined) && (parsedData.gstrcdnr !== null)) {

        const Data = flow(map(Inv => {
          const InvoiceItems = map(InvoiceItems => {
            return {

              'Supplier Gstin': Inv.supplier_gstin,
              'Supplier Name*': Inv.supplier_name,
              'CDNR Number': Inv.cdnr_number,
              'CDNR Date*': Inv.cdnr_date,
              'CDNR Value.*': Inv.cdnr_value,
              'CDNR Type*': Inv.cdnr_type,
              'Place Of Supply*': Inv.pos_id,
              'Supply Type*': Inv.supply_type,
              'Reverse Charge*': Inv.reverse_charge,
              'Rate*': parseFloat(InvoiceItems.gst_rate),
              'Taxable Value*': parseFloat(InvoiceItems.taxable_value),
              'Integrated Tax*': (InvoiceItems.igst === null ? '' : parseFloat(InvoiceItems.igst)),
              'Central Tax*': (InvoiceItems.cgst === null ? '' : parseFloat(InvoiceItems.cgst)),
              'State/UT Tax*': (InvoiceItems.sgst === null ? '' : parseFloat(InvoiceItems.sgst)),
              'Cess': (InvoiceItems.cess === null ? '' : parseFloat(InvoiceItems.cess)),
          }
        })(Inv.gstr2b_cdnr_items.edges)
          return InvoiceItems;
        }),
      flattenDeep)(parsedData.gstrcdnr)

      cdnrDataList = Data;

      }

      if ((parsedData.gstrb2b !== undefined) && (parsedData.gstrb2b !== null) && (parsedData.gstrb2b.length !== 0)) {
        wb_new.Sheets["GSTR-2B-B2B"] = XLSX.utils.json_to_sheet(b2bDataList);
      }
      if ((parsedData.gstrcdnr !== undefined) && (parsedData.gstrcdnr !== null) && (parsedData.gstrcdnr.length !== 0)) {
        wb_new.Sheets["GSTR-2B-CDNR"] = XLSX.utils.json_to_sheet(cdnrDataList);
      }
      
 
    console.log(wb_new);

    if(wb_new.SheetNames.length !== 0){

      var wbout = XLSX.write(wb_new, { bookType: 'xlsx', bookSST: true, type: 'binary' });

      var cur_dt = new Date();

      return fileSaver.saveAs(blob.createBlob([s2ab(wbout)], { type: "application/octet-stream" }), "GSTR2B Download - " + cur_dt + ".xlsx");
  
    }else{
      return {
        status: 'EMPTYSHEET'
      }
    }

    
  },

}
export default excelUtility2B
